import cn from 'classnames';
import { Link } from 'react-router-dom';
import Marquee from 'react-fast-marquee';

import styles from './Dev.module.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const HowItWorkSection = () => {
  return (
    <section className={cn(styles.section, styles.howItWorksSection)}>
      <div className={styles.sectionTitle}>
        How it works
      </div>
      <div className={styles.sectionSubTitle}>
        You’ll see how far you’ve come with just one click.
      </div>
      <Link 
        to="/get-meal-plan"
        className={styles.greenButton}
      >
        Try for free
      </Link>
      <div className={styles.howItWorksMarque}>
        <Marquee speed="30" autoFill>
          <div className={cn(styles.howItWorksItem, styles.forget)}>
            <div>
              Forget the recipe hunt. Skip the ultra processed food. Say goodbye to tasteless meals. Welcome to a smarter, more enjoyable way to eat well.
            </div>
          </div>
          <div className={cn(styles.howItWorksItem, styles.expert)}>
            <div>
              Our expert nutritionists craft perfectly balanced recipes to ensure you get all the essential nutrients and vitamins your body needs.
            </div>
          </div>
          <div className={cn(styles.howItWorksItem, styles.yourBody)}>
            <div>
              Your body is unique—and so is your meal plan. Our AI crafts the perfect nutrition strategy, whether you&apos;re losing weight or building strength.
            </div>
          </div>
          <div className={cn(styles.howItWorksItem, styles.justTellUs)}>
            <div>
              Just tell us your favourite supermarket—we’ll handle the rest. Our food experts select the ingredients, and we’ll add them straight to your online basket.
            </div>
          </div>
          <div className={cn(styles.howItWorksItem, styles.appGuides)}>
            <div>
              Our app guides you through every recipe with easy step-by-step videos—making healthy cooking simple and enjoyable.
            </div>
          </div>
        </Marquee>
      </div>
    </section>
  );
};

export default HowItWorkSection;
